import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { Interview } from 'builder/modules/interview/types'
import { BtnUpgrade } from '../../../BtnUpgrade/BtnUpgrade'
import { Container, Header, LeftContainer, RightContainer, Title, Title2 } from './styles'
export const TRANSLATION_PREFIX = `builder.interview_prep_view.feedbackV2.paywall`
interface Props {
  interview: Interview | undefined
  children: React.ReactNode
}

export const Paywall = ({ children }: Props) => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()

  return (
    <Container>
      <Header>
        <LeftContainer>
          <Title>{i18n.t(`${TRANSLATION_PREFIX}.title`)}</Title>

          <Title2>{i18n.t(`${TRANSLATION_PREFIX}.title2`)}</Title2>
        </LeftContainer>

        {!isPhone && (
          <RightContainer>
            <BtnUpgrade section="ideal_answer" />
          </RightContainer>
        )}
      </Header>
      {children}
      {isPhone && <BtnUpgrade section="ideal_answer" />}
    </Container>
  )
}
